import * as React from 'react';
import { connect } from 'react-redux';
import {
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  Table
} from 'reactstrap';
import { bindActionCreators, Dispatch } from 'redux';

import Localization from '../../config/localization';

import * as BeneficiarySearchAction from '../../actions/BeneficiarySearch';

import * as PartnersApi from '../../api/partners';

import BackButton from '../../components/BackButton';
import Loader from '../../components/Loader';
import ArrowRightSvg from '../../components/Svg/arrowRight';

import { GetAddress } from '../../lib/address';
import Notifications from '../../lib/notifications';
import { GetName, ToString } from '../../lib/utils';
import { CNPValidation, ConsumptionPointValidation, PartnerCodeValidation } from '../../lib/validator';

import './BackOfficeSearch.scss';
import { Routes } from '../../constants/routes';
import { noop } from 'lodash';
import { generatePath } from 'react-router';

type IProps = BackOfficeSearch.IProps & ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

class BackOfficeSearch extends React.Component<IProps, BackOfficeSearch.IState> {
  state: BackOfficeSearch.IState = {
    partners: [],
    search: (this.props.BeneficiarySearch && this.props.BeneficiarySearch.search) || '',

    loading: false,
    loadingMessage: '',

    mouseIn: ''
  };

  componentDidMount() {
    if (this.state.search) {
      return this._searchBeneficiary({ preventDefault: () => undefined } as React.FormEvent<HTMLFormElement>);
    }

    return undefined;
  }

  async componentWillReceiveProps(nextProps = this.props) {
    if ((this.props.location && this.props.location.pathname) !== (nextProps.location && nextProps.location.pathname)) {
      await this.setState({
        partners: [],
        search: (nextProps.BeneficiarySearch && nextProps.BeneficiarySearch.search) || '',

        loading: false,
        loadingMessage: ''
      });

      if (this.state.search) {
        return this._searchBeneficiary({ preventDefault: () => undefined } as React.FormEvent<HTMLFormElement>);
      }

      return this.forceUpdate();
    }
  }

  renderBeneficiaries = () => {
    return this.state.partners.map(partner =>
      partner.consumptionPoints.map(consumptionPoint => (
        <React.Fragment key={consumptionPoint.consumptionPointCode}>
          <tr>
            <td>
              <h5 className="eon-title eon-middle-grey px-1 strong mb-2 w-max-content c-text"
                  onClickCapture={this._goStopPropagation}>
                {GetName({
                  firstName: partner.firstName || partner.companyName,
                  lastName: partner.lastName || partner.companyName2
                })}
              </h5>
              <p className="eon-title eon-middle-grey px-1 w-max-content c-text"
                 onClickCapture={this._goStopPropagation}>
                {partner.partnerCode}
              </p>
            </td>

            <td>
              <h5 className="eon-title eon-middle-grey mb-2 w-max-content c-text"
                  onClickCapture={this._goStopPropagation}>
                {GetAddress(consumptionPoint.address)}
              </h5>
              <p className="eon-title eon-middle-grey w-max-content c-text" onClickCapture={this._goStopPropagation}>
                {consumptionPoint.consumptionPointCode}
              </p>
            </td>
            <td className="c-pointer-no-color" id={consumptionPoint.consumptionPointCode} onMouseEnter={this._openMenu}
                onMouseLeave={this._closeMenu}>
              <Dropdown toggle={noop} inNavbar isOpen={this.state.mouseIn === consumptionPoint.consumptionPointCode}>
                <DropdownToggle className="eon-title eon-darkgrey" nav>
                  <ArrowRightSvg className="m-3 c-pointer" />
                </DropdownToggle>
                <DropdownMenu className="eon-expended-navbar">
                  <DropdownItem
                    className="eon-title eon-darkgrey c-pointer-no-color"
                    name={Routes.BackOfficeAssociation} onClick={this._dropDownClick}
                  >
                    {Localization.backOfficeSearchAids}
                  </DropdownItem>
                  <DropdownItem
                    className="eon-title eon-darkgrey c-pointer-no-color"
                    name={Routes.BackOfficeAdditionAssociation} onClick={this._dropDownClick}
                  >
                    {Localization.backOfficeSearchAdditions}
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </td>
          </tr>

        </React.Fragment>
      ))
    );
  };

  renderTable = () => {
    if (!this._countBeneficiaries()) {
      return null;
    }

    return (
      <Table className="my-4 text-left bg-eon-white" hover>
        <thead>
        <tr>
          <th className="align-top" scope="col">
            <p className="eon-title eon-red">{Localization.backOfficeSearchClient}</p>
            <p className="eon-title eon-red mt-1">{Localization.backOfficeSearchClientCode}</p>
          </th>
          <th className="align-top" scope="col">
            <p className="eon-title eon-red">{Localization.backOfficeSearchAddress}</p>
            <p className="eon-title eon-red mt-1">{Localization.backOfficeSearchConsumptionAddress}</p>
          </th>
          <th className="align-top" scope="col" />
        </tr>
        </thead>
        <tbody>{this.renderBeneficiaries()}</tbody>
      </Table>
    );
  };

  render() {
    return (
      <Container className="back-office-search px-5 py-4 my-4">
        <BackButton />

        <Loader loading={this.state.loading} loadingMessage={this.state.loadingMessage} />

        <h4 className="mt-5 eon-title eon-red text-nowrap">{Localization.backOfficeSearchTitle}</h4>
        <h6 className="mt-2 eon-title eon-middle-grey">{Localization.backOfficeSearchTips}</h6>
        <Form className="mt-5 w-30" onSubmit={this._searchBeneficiary}>
          <FormGroup>
            <Input
              type="text"
              name="search"
              id="search"
              className="eon-input-text eon-input-text-no-label"
              defaultValue={ToString(this.state.search)}
              onChange={this._setSearch}
            />
          </FormGroup>
          <button
            className="eon-button bg-eon-red eon-white mt-4" /* disabled={!this.state.search} onMouseEnter={this.WarnResult} */>
            <span className="px-4">{Localization.backOfficeSearchButton}</span>
          </button>
        </Form>

        {this.renderTable()}
      </Container>
    );
  }

  _countBeneficiaries = () => {
    return this.state.partners && this.state.partners.length;
  };

  _searchValidation = () => {
    if (!PartnerCodeValidation(this.state.search) && !ConsumptionPointValidation(this.state.search) && !CNPValidation(this.state.search)) {
      throw new Error(ToString(Localization.formatString(Localization.backOfficeSearchError, this.state.search)));
    }

    return undefined;
  };

  _searchBeneficiary = async (event: React.FormEvent<HTMLFormElement>) => {
    try {
      event.preventDefault();

      if (!this.state.search) {
        return undefined;
      }

      await this.setState({ loading: true, partners: [] });

      this._searchValidation();

      const response = await PartnersApi.GetPartner({ search: this.state.search });

      if (!response.data || !response.data.length) {
        Notifications.warning(ToString(Localization.formatString(Localization.backOfficeSearchResultsNotFound, this.state.search)));
      }

      return this.setState({ partners: response.data || [], loading: false });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _setSearch = async (event: React.ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    await this.setState({ search: ToString(element.value).trim() });

    await this.props.ClearSearch();

    return this.props.SetSearch(this.state.search);
  };

  _goStopPropagation = (event: React.MouseEvent<HTMLElement>) => {
    if (!event || !event.stopPropagation) {
      return undefined;
    }
    return event.stopPropagation();
  };

  _closeMenu = () => {
    return this.setState({ mouseIn: '' });
  };

  _openMenu = (event: React.MouseEvent<HTMLTableCellElement>) => {
    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    const consumptionPointCode = element.id;

    return this.setState({ mouseIn: consumptionPointCode });
  };

  _dropDownClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const { mouseIn: consumptionPoint } = this.state;
    const target = event.currentTarget || event.target || {};

    this.setState({ mouseIn: '' });

    return this.props.history.push(generatePath(target.name, { consumptionPoint }));
  };
}

const mapStateToProps = (state: General.Store) => ({ BeneficiarySearch: state.BeneficiarySearch });

const mapDispatchToProps = (dispatch: Dispatch) => ({ ...bindActionCreators({ ...BeneficiarySearchAction }, dispatch) });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BackOfficeSearch);
